module.exports = __webpack_public_path__ + "img/plusedit.c1649ec7.svg";